export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0002s_0000_Black-&-White-25.c0ef21c5.png";